
import * as ipxRuntime$CcUtZilBmyKP_jNzS8ynlH6A8yrxvYHlsOwh7J6gZMI from '/home/zebrafashion/zebrafashion.com/releases/75947690/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {
    "listing": {
      "modifiers": {
        "height": 227,
        "fit": "fill",
        "format": "webp"
      }
    }
  },
  "provider": "ipx",
  "domains": [
    "zebrafashion.s3.eu-central-1.amazonaws.com"
  ],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ],
  "quality": 80
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$CcUtZilBmyKP_jNzS8ynlH6A8yrxvYHlsOwh7J6gZMI, defaults: {} }
}
        